module.exports = __webpack_public_path__ + "img/pt-root-01.571aca3b.svg";